/**
 * Creates a string for use in a description template.
 *
 * Example return: [hello](parameter-template).
 *
 * @param parameterValue - The parameter value to be formatted.
 * @param parameterName - The parameter name.
 *
 * @returns Returns the formatted string.
 */
// eslint-disable-next-line import/prefer-default-export -- Allows export to be renamed to something shorter.
export function createFormatForDescription(
  parameterValue: string,
  parameterName: string,
): string {
  return `#[${parameterValue}]#{${parameterName}}`
}
